import { useEffect, useState } from 'react'
import constate from 'constate'
import { useQueryClient } from 'react-query'
import { UPDATES_QUERY_KEY, useUpdatesQuery } from '../queries/useUpdatesQuery'
import { TDatasetUpdate } from '../definitions'

const useUpdates = () => {
  const [isParsing, setIsParsing] = useState(false)
  const [isFetching, setIsFetching] = useState(false)
  const [isError, setIsError] = useState(false)
  const queryClient = useQueryClient()
  const { refetch, isFetched } = useUpdatesQuery()

  useEffect(() => {
    setIsParsing(false)
    refetch().then(() => {
      setIsFetching(false)
    })
  }, [])

  return {
    fetchUpdates: () => {
      setIsParsing(true)
      setIsFetching(true)
      setIsError(false)
    },
    isFetching: isFetching || (!isError && !isFetched),
    isParsing,
    isError,
    updates: queryClient.getQueryData<TDatasetUpdate[]>(UPDATES_QUERY_KEY)
  }
}

export const [UpdatesProvider, useUpdatesContext] = constate(useUpdates)
